import React from 'react';
import RateSeparatorLabel from './RateSeparatorLabel';
import { RATE_SEPARATOR_DESIGNS } from '../constants/bookingConst';
import '../css/RateSeparatorRow.css';

/**
 * One rate separator row in a time slot grid — the guest screen and the admin
 * grid both draw these where each hourly rate starts (lines planned by
 * rateSeparatorUtil.planRateSeparators).
 *
 * Spans every column of its grid line. Design 1's pill is centred over the
 * court columns only; Design 2's bar runs the full width. The host grid tunes
 * the layout through CSS custom properties (see RateSeparatorRow.css).
 *
 * @param {object} props
 * @param {number} props.line - the grid row line this separator sits on
 * @param {string} props.design - a RATE_SEPARATOR_DESIGNS value
 * @param {object} props.band - the rate band ({ name, icon, color, ... })
 * @param {string} props.price - formatted price, e.g. "₱650/hr"
 * @param {string} props.hours - formatted hours, e.g. "12:00 NN – 5:00 PM"
 * @returns {JSX.Element}
 */
function RateSeparatorRow({ line, design, band, price, hours }) {
  const isBar = design === RATE_SEPARATOR_DESIGNS.BAR;
  return (
    <div
      className={`rsr-row${isBar ? ' rsr-row-bar' : ''}`}
      style={{ gridRow: line, gridColumn: '1 / -1' }}
    >
      <span className="rsr-inner">
        <RateSeparatorLabel
          design={design}
          name={band.name}
          icon={band.icon}
          color={band.color}
          price={price}
          hours={hours}
        />
      </span>
    </div>
  );
}

export default RateSeparatorRow;
